import React, { memo } from "react";
import clsx from "clsx";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import { useCarConfigSelector } from "../../../../../redux/store";
import EfficiencyClass from "../../eco/EfficiencyClass";
import { getEcoTagType } from "../../../../../../../shared-logic/utils/typedUtils";
import { getEcoBadgeType } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { getEcoBadgeUrl } from "../../../../../../../../common-deprecated/utils";
import styles from "./Overview.module.scss";
import EcoLabel from "../../../../../../shared-components/css-modules/lexus/molecules/EcoLabel";
import HybridLabel from "../../../../../../shared-components/css-modules/lexus/molecules/HybridLabel";
import { getCarConfigLabel } from "../../../../../utils/labelUtils";
import { useAphEfficiencyLabel } from "../../../../../hooks/useAphEfficiencyLabel";
import { ecoTagToLabel } from "../../../../../../../../common-deprecated/utils/ecoTagUtils";
import { getEngineVisual } from "../../../../../utils/visualUtils";
import { CarConfigConfigureSection } from "../../../../../utils/types/SectionTypes";
import { useComponentRegistry } from "../../../componentRegistry";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";

const OverviewEngine = (): JSX.Element => {
    const car = useCarConfigSelector((state) => state.car);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const useLbxJourney = useCarConfigSelector((state) => state.commonSettings.query.useLbxJourney || false);

    const ecoTag = getEcoTagType(car.motorization.engine);
    const ecoTagLabel = ecoTagToLabel(ecoTag);
    const ecoBadge = getEcoBadgeType(commonSettings, ecoTag, car.model.id);
    const ecoBadgeUrl = getEcoBadgeUrl(ecoBadge, commonSettings);

    const efficiencyLabelConfig = useAphEfficiencyLabel();
    const carConfigMotorization = useCarConfigSelector((state) => state.carConfigMotorization);
    const imageEngine = getEngineVisual(car, carConfigMotorization, commonSettings);
    const OverviewItemWrapper = useComponentRegistry("OverviewItemWrapper");

    return (
        <OverviewItemWrapper
            title="carConfigOverviewTileEngine"
            editSection={useLbxJourney ? CarConfigConfigureSectionsLbx.Powertrain : CarConfigConfigureSection.Engine}
            image={imageEngine}
        >
            <div>
                <div className={clsx(styles.flex, styles["engine-labels"])}>
                    {ecoBadgeUrl && <EcoLabel url={ecoBadgeUrl} />}
                    {efficiencyLabelConfig.show && <EfficiencyClass label={efficiencyLabelConfig.label} />}
                    {ecoTagLabel && (
                        <HybridLabel
                            variant={ecoTag}
                            label={getCarConfigLabel({ commonSettings, carConfigSettings }, ecoTagLabel)}
                        />
                    )}
                </div>
                <Text variant="apheleia-body-small" spacing="spacing-0">
                    {car.motorization.wheeldrive.name}
                    <br />
                    {car.motorization.engine.name}, {car.motorization.transmission.name}
                </Text>
            </div>
        </OverviewItemWrapper>
    );
};

export default memo(OverviewEngine);
